import styled from 'styled-components';
import type { IslandMode } from '../../BaseSimpleIsland';
import { PEEKING_HOVER_TRANSLATE } from '../../BaseSimpleIsland';


// todo BUILD-1700 - update these vars to use BaseSimpleIsland values
interface OnIslandWorkflowRoutingNodeContainerStyleProps {
  islandMode: IslandMode;
}

export const OnIslandWorkflowRoutingNodeContainer = styled.div<OnIslandWorkflowRoutingNodeContainerStyleProps>`
  ${p => p.islandMode === 'peeking' && `
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.35);
    &:hover {
      transform: translateX(-${PEEKING_HOVER_TRANSLATE}px);
    }
    transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  `}
  border-radius: var(--cl-radius-1);
`;
